import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { TextField, MenuItem, FormHelperText } from "@material-ui/core";

function SelectField({ fieldName, options, helperText, valueKey, labelKey, renderOption, onChange, ...rest }) {
    function renderOptionHandler(option, index) {
        if (renderOption) {
            return renderOption(option, index);
        } else {
            return (
                <MenuItem key={index} value={option[valueKey]}>
                    {option[labelKey]}
                </MenuItem>
            );
        }
    }

    const onChangeHandler = (event, field, form) => {
        field.onChange(event);
        if (onChange && typeof onChange === "function") {
            onChange(field.name, event && event.target && event.target.value, form);
        }
    };

    return (
        <Field name={fieldName}>
            {({ field, form }) => (
                <>
                    <TextField
                        select
                        {...field}
                        {...rest}
                        onChange={(e) => onChangeHandler(e, field, form)}
                        error={Boolean(form.touched[field.name]) && Boolean(form.errors[field.name])}
                    >
                        {options.map(renderOptionHandler)}
                    </TextField>
                    {form.touched[field.name] && form.errors[field.name] && (
                        <FormHelperText variant="outlined" error={true}>
                            {form.errors[field.name]}
                        </FormHelperText>
                    )}
                    {helperText && !form.errors[field.name] && <FormHelperText variant="outlined">{helperText}</FormHelperText>}
                </>
            )}
        </Field>
    );
}

SelectField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    variant: PropTypes.string,
    size: PropTypes.string,
    margin: PropTypes.string,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,
    renderOption: PropTypes.func,
    onChange: PropTypes.func,
};

SelectField.defaultProps = {
    variant: "outlined",
    size: "small",
    margin: "dense",
    fullWidth: true,
    helperText: undefined,
    valueKey: "value",
    labelKey: "label",
    renderOption: undefined,
    onChange: undefined,
};

export default SelectField;
